import React, { useReducer, useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import * as yup from "yup";
import {
  Button,
  Modal,
} from "react-bootstrap";
import { Store as toast } from "react-notifications-component";
import { toastNotification } from "../../../../../config/toastNotification";
import BlockSuccessMessage from "../../../../UI/errorMessages/BlockSuccessMessage";
import FormErrorMessage from "../../../../UI/errorMessages/FormErrorMessage";
import CMSFormInput from "../../../../UI/forms/CMSFormInput";
import axios from "../../../../../config/axios";
import {
  addItemInitialState,
  addItemReducer,
} from "../../reducers/addQuestionReducer";
import BlockErrorMessage from "../../../../UI/errorMessages/BlockErrorMessage";


const UpdateQuestionOptionModal = ({ show, setShow, option, loadData }) => {
  const [state, dispatch] = useReducer(addItemReducer, addItemInitialState);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    dispatch({
      type: "FETCH_SUCCESS",
      payload: {},
    });
  }, [show]);

  const onSubmit = async (data, resetForm) => {
    dispatch({
      type: "FORM_SUBMISSION_REQUEST",
    });

    try {
      const res = await axios.post(
        `poll-question-options/update-option/${option._id}`,
        data
      ); //

      resetForm();
      handleClose();
      dispatch({
        type: "FORM_INITIAL_STAGE",
      });
      toast.addNotification({
        ...toastNotification,
        title: "Success!",
        message: `Option updated successfully.`,
        type: "success",
      });
      loadData();
    } catch (error) {
      dispatch({
        type: "FORM_SUBMISSION_FAILED",
        payload: error,
      });
      setTimeout(() => {
        dispatch({
          type: "FORM_INITIAL_STAGE",
        });
      }, 5000);
    }
  };

  return (
    <Formik
      initialValues={{
        option: option.option,
        sortOrder: option.sortOrder,
      }}
      validationSchema={yup.object({
        option: yup.string().required("Required"),
        sortOrder: yup.number(),
      })}
      enableReinitialize={true}
      validateOnChange={true}
      validateOnBlur={false}
      onSubmit={async (values, { resetForm }) => {
        //console.log(values);
        onSubmit(values, resetForm)
      }}
    >
      {(form) => (
        <Modal show={show} onHide={handleClose} size="lg">
          {/* {console.log(form.errors)} */}
          {state.isLoading && (
            <div class="overlay ">
              <i class="fas fa-2x fa-sync-alt text-white fa-spin"></i>
            </div>
          )}

          {state.error && state.status === "fetchFailed" ? (
            <BlockErrorMessage error={state.error} />
          ) : (
            <>
              <Form onSubmit={form.handleSubmit}>
                <Modal.Header closeButton>
                  <Modal.Title>Update Option </Modal.Title>
                </Modal.Header>


                {state.status === "submitted" ? (
                  <Modal.Body>
                    <BlockSuccessMessage
                      heading="Done!"
                      message={`Option added to question successfully.`}
                    />
                  </Modal.Body>
                ) : (
                  <>
                    <Modal.Body>
                      {state.error && <FormErrorMessage error={state.error} />}

                      <CMSFormInput
                        name="option"
                        label="Option"
                        form={form}
                        required={true}
                      />

                      <CMSFormInput
                        name="sortOrder"
                        label="Sort Order"
                        form={form}
                        required={false}
                      />

                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={handleClose}>
                        Close
                      </Button>
                      <Button variant="primary" type="submit">
                        Submit
                      </Button>
                    </Modal.Footer>
                  </>
                )}
              </Form>
            </>
          )}
        </Modal>
      )}
    </Formik>
  );
};

export default UpdateQuestionOptionModal;
